import { Text as PageText } from '@web/components/page-components/Text'
import type { Text as TextProps } from '@web/graphql-components'
import PageAmountRaisedHandler from './PageAmountRaisedHandler'
import { Box } from '@web/components/atoms/Layout'
import { useEffect } from 'react'
import { useMergeFields } from '@web/components/page-components/Text/MergeTags/MergeTag'
import CampaignAmountRaisedHandler from './CampaignAmountRaisedHandler'

const Text = (props: TextProps) => {
  const mergeTags = props.styles?.options?.mergeTags || {}

  useEffect(() => {
    useMergeFields.getState().addTagsToPostProcess(Object.keys(mergeTags))
  }, [mergeTags])

  return (
    <Box display="contents">
      <PageAmountRaisedHandler />
      <CampaignAmountRaisedHandler />
      <PageText {...props} />
    </Box>
  )
}

export default Text
